import { useEffect, useRef } from "react";
import { HUBSPOT_SCRIPT_URL } from "../lib/hubspot-config";

/**
 * HubSpot tracking script loader for public pages.
 * This loads the HubSpot script with chat disabled (loadImmediately: false)
 * so that HubSpot's validation can detect the tracking code.
 *
 * The HubSpotProvider will later enable chat for authenticated users
 * using the already-loaded script.
 */
export const HubSpotTracking = () => {
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    // Don't load if already loaded
    if (
      scriptLoadedRef.current ||
      document.getElementById("hs-script-loader")
    ) {
      return;
    }
    scriptLoadedRef.current = true;

    // Configure HubSpot to NOT load chat widget immediately
    // This allows tracking to work while keeping chat disabled until user logs in
    window.hsConversationsSettings = {
      loadImmediately: false,
    };

    // Initialize tracking queue
    window._hsq = window._hsq || [];

    // Load the HubSpot script
    const script = document.createElement("script");
    script.src = HUBSPOT_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.id = "hs-script-loader";
    script.type = "text/javascript";

    document.body.appendChild(script);
  }, []);

  return null;
};
